import {IDS} from "./pnp-accred-action-id.constants";
import {TAB_DISABLE, TAB_HIDE} from "../../../common/tabs/tabs.constants";

const QUERY_PARAMS = '?param1&param2';

export const tabsState = {
    name: IDS.app_pnp_accred,
    redirectTo: IDS.app_pnp_accred_list,
    url: '/accred',
};

export const tabListState = {
    name: IDS.app_pnp_accred_list,
    url: '/list',
    // component: 'tabs',
    component: 'pnpAccredList',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: TAB_HIDE,
            id: IDS.app_pnp_accred,
            state: [
                IDS.app_pnp_accred_details,
                IDS.app_pnp_accred_add,
            ]
        })
    }
};
tabListState.onEnter.$inject = ['$ngRedux'];

export const tabDetailsState = {
    name: IDS.app_pnp_accred_details,
    url: '/details',
    component: 'pnpAccredDetails',
};